import {
  FETCHING_COLLECTIONS_COUNT,
  FETCHING_COLLECTIONS_COUNT_SUCCEEDED,
  FETCHING_COLLECTIONS_COUNT_FAILED,
  FETCHING_COLLECTIONS,
  FETCHING_COLLECTIONS_SUCCEEDED,
  FETCHING_COLLECTIONS_FAILED,
  MIGRATING_COLLECTIONS,
  MIGRATINGCOLLECTIONS_SUCCEEDED,
  MIGRATINGCOLLECTIONS_FAILED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const COLLECTIONS_BASE_URL = `${API_URL}/api/1.0/collections`;




export const fetchCollectionsCount = createAction(FETCHING_COLLECTIONS_COUNT);
const fetchingCollectionsCountSucceeded = createAction(
  FETCHING_COLLECTIONS_COUNT_SUCCEEDED
);
const fetchingCollectionsCountFailed = createAction(FETCHING_COLLECTIONS_COUNT_FAILED);

function* fetchCollectionsCountSaga(action) {
  let { account } = action.payload;
  
  let url = buildUrl(COLLECTIONS_BASE_URL, { path: "/count" });
  
  const fetchCollectionsCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account: account },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionsCountAPI);
    yield put(fetchingCollectionsCountSucceeded(response));
  } catch (error) {
    yield put(fetchingCollectionsCountFailed(error));
  }
}
export const fetchCollections = createAction(FETCHING_COLLECTIONS);
const fetchingCollectionsSucceeded = createAction(FETCHING_COLLECTIONS_SUCCEEDED);
const fetchingCollectionsFailed = createAction(FETCHING_COLLECTIONS_FAILED);

function* fetchCollectionsSaga(action) {
  let { page,limit, filters } = action.payload;

  let url = buildUrl(COLLECTIONS_BASE_URL);
  const fetchCollectionsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: { page,limit},
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionsAPI);
    yield put(fetchingCollectionsSucceeded(response));
  } catch (error) {
    yield put(fetchingCollectionsFailed(error));
  }
}
//migratecollections
export const migratecollections = createAction(MIGRATING_COLLECTIONS);
const migrateCollectionsSucceeded = createAction(MIGRATINGCOLLECTIONS_SUCCEEDED);
const migrateCollectionsFailed = createAction(MIGRATINGCOLLECTIONS_FAILED);
function* fetchMigratecollections(action) {
  let { filters } = action.payload;

  let url = buildUrl(COLLECTIONS_BASE_URL, { path: "/transfer-ownership" });
  const migrateCollectionsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(migrateCollectionsAPI);
    yield put(migrateCollectionsSucceeded(response));
  } catch (error) {
    yield put(migrateCollectionsFailed(error));
  }
}


export default function* collectionsSaga() {
  yield takeLatest(FETCHING_COLLECTIONS_COUNT, fetchCollectionsCountSaga);
  yield takeLatest(FETCHING_COLLECTIONS, fetchCollectionsSaga);
  yield takeLatest(MIGRATING_COLLECTIONS, fetchMigratecollections);
  
 

 

}
